var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("add-quick-add-button")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      label: _vm.$ct("add-quick-add-button-type"),
                      items: _vm.typeItems,
                    },
                    model: {
                      value: _vm.buttonType,
                      callback: function ($$v) {
                        _vm.buttonType = $$v
                      },
                      expression: "buttonType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.showParam
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-sale-type-select", {
                            attrs: {
                              label: _vm.$ct("sale-type"),
                              "contact-group-id": _vm.saleTypeContactGroupId,
                              "use-id": "",
                            },
                            model: {
                              value: _vm.numParam,
                              callback: function ($$v) {
                                _vm.numParam = $$v
                              },
                              expression: "numParam",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.close")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }